import { toast } from 'react-toastify'
import { StoreonModule } from 'storeon'
import { api } from '@/api'
import { ICertificate } from '@/types'
import { Events, State } from '../../interfaces'
import { ICertificateStore } from '../interfaces/Certificate'

export const certificatesModule: StoreonModule<State, Events> = (store) => {
  store.on('@init', () => ({
    // Общий список сертификатов
    certificates: {
      results: [],
      count: 0,
      next: null,
      previous: null
    },
    certificatesParamsApi: {
      page: 1,
      limit: 30
    },

    // Список сертификатов для определенного контрагента
    certificatesUser: {
      count: 0,
      next: null,
      previous: null,
      results: []
    },

    // Список шаблонов сертификатов
    arrCertificatesGenerator: [],

    // Статус загрузки
    statusLoadCertificates: false
  }))

  // Общий список сертификатов
  store.on('certificates/get', async (state, event) => {
    try {
      store.dispatch('statusLoadCertificates', true)
      const data = await api.certificate.getCertificates({
        ...state.certificatesParamsApi,
        ...event
      })
      store.dispatch('certificates/save', data)
      store.dispatch('statusLoadCertificates', false)
    } catch (e) {
      toast.error('Ошибка получения cертификатов!')
    }
  })

  store.on('certificates/save', (_state, event) => {
    try {
      return {
        certificates: {
          ...event,
          results: event.results.map((item: ICertificate) => {
            return {
              ...item,
              flag: false
            }
          })
        }
      }
    } catch (e) {
      console.log(e)
    }
    return null
  })

  store.on('certificatesApi/change', (state, event) => {
    return { certificatesParamsApi: { ...state.certificatesParamsApi, ...event } }
  })

  store.on('certificatesApi/clear', () => {
    return {
      certificatesParamsApi: {
        page: 1,
        number: null,
        limit: 10
      }
    }
  })

  store.on('changeCheckedCertificate/set', (state, event) => {
    return {
      certificates: {
        ...state.certificates,
        results: state.certificates.results.map((item: ICertificateStore) => {
          if (event === 'all') {
            return {
              ...item,
              flag: true
            }
          }
          if (event === 'takeOf') {
            return {
              ...item,
              flag: false
            }
          }
          if (typeof event === 'number' && item.id === event) {
            return {
              ...item,
              flag: !item.flag
            }
          }
          return {
            ...item
          }
        })
      }
    }
  })

  // Список сертификатов для определенного контрагента
  store.on('certificatesUser/get', async (_state, event) => {
    try {
      const data = await api.user.getCertificatesUser(event)
      store.dispatch('certificatesUser/save', data)
    } catch (e) {
      store.dispatch('certificatesUser/save', {
        count: 0,
        results: [],
        previous: null,
        next: null
      })
    }
  })

  store.on('certificatesUser/save', (_state, event) => {
    try {
      return {
        certificatesUser: event
      }
    } catch (e) {
      console.log(e)
      return {
        certificatesUser: {
          count: 0,
          results: [],
          previous: null,
          next: null
        }
      }
    }
  })

  // Список шаблонов сертификатов
  store.on('certificatesGenerate/get', async (state, event) => {
    try {
      const { results } = await api.certificate.getCertificatesGenerator(event)
      store.dispatch('certificatesGenerate/save', results)
    } catch (e) {
      store.dispatch('certificatesUser/save', {
        count: 0,
        results: [],
        previous: null,
        next: null
      })
    }
  })

  store.on('certificatesGenerate/save', (_state, event) => {
    try {
      return {
        arrCertificatesGenerator: event
      }
    } catch (e) {
      return {
        arrCertificatesGenerator: []
      }
    }
  })

  // Статус загрузки
  store.on('statusLoadCertificates', (_state, event) => {
    return { statusLoadCertificates: event }
  })
}
